module.exports = __webpack_public_path__ + "media/images/whatsapp copy-deb69c014b799f122acfaf3a740743c5.svg";